module.exports = __webpack_public_path__ + "static/media/Poppins-Medium.f61a4eb2.ttf";